<template>
  <div class="more-page common-bg" >
    <van-nav-bar fixed title="更多" left-text="" left-arrow @click-left="onClickLeft" />
    <div style="height: 30px"></div>
        <div class="bosfs-new-box">

            <div class="title">功能中心</div>
            <div class="bosfs-new">
                <van-grid clickable :column-num="5">
                    <van-grid-item icon="home-o" text="活动" to="/activityRecord">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_yh.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="任务" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_rw.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="盲盒抽奖" to="/">
                        <template #icon>
                        <van-image  width="1rem" height="1rem" fit="contain" src="/static/newImg/menu/apng_icon_mhcj.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="幸运转盘" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_xyzp.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="search" text="金融SVIP" to="/activityRecord">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_jrsvip.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="search" text="返水" to="/fanshui">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_fs.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="利息宝" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_yeb.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="公积金" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_gjj.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="折扣券" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_zkq.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="待领取" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_djl.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="领取记录" to="/">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_lqjl.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="search" text="代理专属" to="/">
                    <template #icon>
                        <van-image  width="1rem" height="1rem" fit="contain" src="/static/newImg/menu/apng_icon_kyd.avif"/>
                    </template>
                    </van-grid-item>
                </van-grid>
            </div>

            <div class="title">资金管理</div>
            <div class="bosfs-new">
                <van-grid clickable :column-num="5">
                    <van-grid-item icon="home-o" text="存款" to="/recharge">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_cz.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="取款" to="/withdrawal">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_tx.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="账户明细" to="/money">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_zhmx.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="投注记录" to="/betRecord">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_tzjl.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="个人报表" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_grbb.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="提现管理" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_txgl.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="立即分享" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_ljfx.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="投注任务" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_jh.avif"/>
                    </template>
                    </van-grid-item>
                </van-grid>
            </div>
            
            <div class="title">支持中心</div>
            <div class="bosfs-new">
                <van-grid clickable :column-num="5">
                    <!-- <van-grid-item icon="home-o" text="币种" to="">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_sz.avif"/>
                    </template>
                    </van-grid-item> -->

                    <van-grid-item icon="home-o" text="APP下载" to="/app">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_app.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="有奖反馈" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_yjfq.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="世界杯" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_sszx.avif"/>
                    </template>
                    </van-grid-item>
                    <van-grid-item icon="home-o" text="吃瓜黑料" to="">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_cgw.avif"/>
                    </template>
                    </van-grid-item>
                </van-grid>
            </div>


            <div class="title">账户安全</div>
            <div class="bosfs-new">
                <van-grid clickable :column-num="5">
                    <van-grid-item icon="home-o" text="个人资料" to="/userInfo">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_sz.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="安全中心" to="/userCent">
                    <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_aqzx.avif"/>
                    </template>
                    </van-grid-item>

                    <van-grid-item icon="home-o" text="找到我们" to="/boutBallBetInfo?type=4">
                        <template #icon>
                        <van-image  width=".93rem" height=".93rem" fit="contain" src="/static/newImg/menu/icon_zdwm.avif"/>
                    </template>
                    </van-grid-item>
                </van-grid>
            </div>
            
    </div>
  </div>
</template>

<script>
export default {
  name: 'moreMenu',
  data () {
    return {
    }
  },
  
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';
.more-page{
    min-height: 100vh;
}
.bosfs-new-box{
    margin: .8rem 0;padding: 0 .3rem;
    .title{
      font-size: .36rem;
      color: #fff;
      margin-bottom: .14rem;
      padding-left: .14rem;
    }
  }
  .bosfs-new{
    background-color: #292A2c;
    border: 1px solid #3B3C3D;
    border-radius: .2rem;
    margin-bottom: .3rem;

    
  }
</style>
<style scoped>
.bosfs-new /deep/ .grid-item-content-background-color{background-color: transparent !important;}
.bosfs-new /deep/ .van-grid-item__content{background-color: transparent !important;}
.bosfs-new /deep/ .van-grid-item__text{color: #fff !important;text-align: center;}
</style>


// WEBPACK FOOTER //
// src/components/moreMenu.vue